import type { FaireProductEntity } from "../../entity_types/product";

export const p_xehg4jzjq5: FaireProductEntity = {
  token: "p_xehg4jzjq5",
  type: "product",
  name: "Storage Stand with 2 Trays-14\"H",
  brandToken: "b_a8n58zvndo",
  brandName: "Abbott",
  imageUrl: "https://cdn.faire.com/fastly/db2758bd1657d2ba8a3b4b475ea391866497c02814887bdb58d14a5d68728de2.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/5b88a48f329bf415f46a53f98c9d1b100abefba4d88d64a3dec3202ba706206a.jpeg",
    "https://cdn.faire.com/fastly/60a0fa498be28b4aca554dcc0f6c86986d51f0255bc844c39fe21d0d27566c8c.jpeg"
  ],
  priceDollars: 47.5,
  description: "This Storage Stand with 2 Trays offers both style and functionality. The sturdy metal construction ensures durability, while the two open shelves provide ample space for displaying decor or organizing essentials. Measuring approximately 14 inches in height, it's a versatile and chic addition to any room. Handcrafted in India.",
  tags: [],
  msrpDollars: 95,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-05-06T19:58:09.550Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
